import { useState, useEffect, useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { connect } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import Distribution_Planning_TabComponent from "../../common/Components/Distribution_Planning/TabComponent";
import TabComponent from '../../common/Components/TabComponent';
import AlertDialogBox from "../../common/Components/AlertDialogBox";
import ViewAllAlerts from "../../common/Components/ViewAllAlerts";
import PowerBIReportEmbed from '../PowerBIReportEmbed';
import { setPowerBiData } from '../../store/Actions';
import KPIService from '../../services/console_services/KPI';
import MapService from '../../services/console_services/Map';
import { setViewPowerBi } from '../../store/Actions';
import Distribution_Planning_AlertDialogBox from '../../common/Components/Distribution_Planning/AlertDialogBox';
import useTabList from '../../common/TabList';
import UserDetailsServices from '../../services/console_services/LoginLogot';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));


const Distribution_Planning = ({
  tabIndex,
  Network,
  DC,
  Products,
  dateRangeDIP,
  applyFilter,
  Division,
  PL3,
  periodType,
  role,
  viewPowerBi,
  setViewPowerBi,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [viewAll, setViewAll] = useState(false);
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const dispatch = useDispatch();
  const TabList = useTabList();
  const currentTabData = useMemo(() => TabList["Distribution_Planning"][tabIndex], [tabIndex]);

  useEffect(() => {
    const fetchMapData = async () => {
      const params = {
        name: currentTabData.value,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          Products,
          startDate: dateRangeDIP[0],
          endDate: dateRangeDIP[1],
        },
      };
      setMapLoading(true);
      MapService.getMAP(params, instance).then(data => {
        if (data?.data) {
          setMapData(data?.data);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setMapLoading(false));
    };
    fetchMapData();
    fetchCreateAlertsWithUser();
  }, [tabIndex, role, applyFilter, DC, Network, PL3, Division, Products, dateRangeDIP]);

  const fetchCreateAlertsWithUser = () => {
    if (currentTabData.value) {
      UserDetailsServices.createAlertsWithUser({
        module: currentTabData.value
      }, instance);
      UserDetailsServices.createAlertsWithThresholdUser({
        module: currentTabData.value
      }, instance);
    }
  };

  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData.value,
        periodType,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          Products,
          startDate: dateRangeDIP[0],
          endDate: dateRangeDIP[1],
        },
      };

      setKPILoading(true);
      KPIService.getKPI(params, instance).then(data => {
        if (data?.response) {
          setKPIData(data?.response);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setKPILoading(false));
    };
    fetchKPIData();
  }, [tabIndex, periodType, role, applyFilter, DC, Network]);

  const toggleViewAll = () => setViewAll(!viewAll);
  const toggleViewPowerBi = (val) => {
    setViewPowerBi(!viewPowerBi);
    dispatch(setPowerBiData(val));
  };

  return (
    <Box className={classes.root}>
      {viewPowerBi ? (
        <PowerBIReportEmbed />
      ) : (
        <>
          {!viewAll ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <TabComponent
                  KPIData={KPIData}
                  mapData={mapData}
                  tabList={TabList["Distribution_Planning"]}
                  MapLoading={MapLoading}
                  KPILoading={KPILoading}
                  Module={currentTabData.value}
                  graphViewTabList={TabList["Distribution_Planning"][tabIndex].graphViewTabList}
                />
              </Grid>
              <Grid item xs={12} md={3} className={classes.gridItem} sx={{ mt: '93px' }}>
                <AlertDialogBox
                  handleViewAll={toggleViewAll}
                  handleViewPowerBi={toggleViewPowerBi}
                  viewAll={viewAll}
                />
              </Grid>
            </Grid>
          ) : (
            <ViewAllAlerts viewAll={viewAll} handleClose={toggleViewAll} />
          )}
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  dateRangeDIP: state.filter.dateRangeDIP,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
});

const mapDispatchToProps = {
  setViewPowerBi,
};


export default connect(mapStateToProps, mapDispatchToProps)(Distribution_Planning);
